import Layout from "./Layout.jsx";
import Login from "./Login.jsx";
import PatientSignup from "./PatientSignup.jsx";
import PracticeOwnerSignup from "./PracticeOwnerSignup.jsx";
import PatientManagement from "./PatientManagement.jsx";
import PatientDetails from "./PatientDetails.jsx";

import DashboardRouter from "../components/DashboardRouter";
import BlockAccessForIncorrectUserType from "../components/auth/BlockAccessForIncorrectUserType";
import ProfileCompletionGuard from "../components/auth/ProfileCompletionGuard";

import BloodTests from "./BloodTests";

import Analytics from "./Analytics";

import ClinicalNotes from "./ClinicalNotes";

import Inventory from "./Inventory";

import Services from "./Services";

import Prescriptions from "./Prescriptions";

import PatientPortal from "./PatientPortal";

import ConciergeTesting from "./ConciergeTesting";

import Reports from "./Reports";

import BiologicalAgeComingSoon from "./BiologicalAgeComingSoon";

import WearablesComingSoon from "./WearablesComingSoon";

import Billing from "./Billing";

import Settings from "./Settings";

import Calendar from "./Calendar";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

const PAGES = {
  Dashboard: DashboardRouter,

  BloodTests: BloodTests,

  Analytics: Analytics,

  ClinicalNotes: ClinicalNotes,

  Inventory: Inventory,

  Services: Services,

  Prescriptions: Prescriptions,

  PatientPortal: PatientPortal,

  PatientManagement: PatientManagement,

  ConciergeTesting: ConciergeTesting,

  Reports: Reports,

  BiologicalAge: BiologicalAgeComingSoon,

  Wearables: WearablesComingSoon,

  ComprehensiveBilling: Billing,

  Settings: Settings,

  Calendar: Calendar,
};

function _getCurrentPage(url) {
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }
  let urlLastPart = url.split("/").pop();
  if (urlLastPart.includes("?")) {
    urlLastPart = urlLastPart.split("?")[0];
  }

  const pageName = Object.keys(PAGES).find(
    (page) => page.toLowerCase() === urlLastPart.toLowerCase()
  );
  return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
  const location = useLocation();
  const currentPage = _getCurrentPage(location.pathname);

  // Don't wrap login and signup pages in Layout
  if (
    location.pathname === "/login" ||
    location.pathname === "/patient-signup" ||
    location.pathname === "/practice-owner-signup"
  ) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/patient-signup" element={<PatientSignup />} />
        <Route
          path="/practice-owner-signup"
          element={<PracticeOwnerSignup />}
        />
      </Routes>
    );
  }

  return (
    <Layout currentPageName={currentPage}>
      <BlockAccessForIncorrectUserType>
        <ProfileCompletionGuard>
          <Routes>
            <Route path="/" element={<DashboardRouter />} />

            <Route path="/Dashboard" element={<DashboardRouter />} />

            <Route path="/BloodTests" element={<BloodTests />} />

            <Route path="/Analytics" element={<Analytics />} />

            <Route path="/ClinicalNotes" element={<ClinicalNotes />} />

            <Route path="/Inventory" element={<Inventory />} />

            <Route path="/Services" element={<Services />} />

            <Route path="/Prescriptions" element={<Prescriptions />} />

            <Route path="/PatientPortal" element={<PatientPortal />} />

            <Route path="/PatientManagement" element={<PatientManagement />} />

            <Route path="/patients/:patientId" element={<PatientDetails />} />

            <Route path="/ConciergeTesting" element={<ConciergeTesting />} />

            <Route path="/Reports" element={<Reports />} />

            <Route
              path="/BiologicalAge"
              element={<BiologicalAgeComingSoon />}
            />

            <Route path="/Wearables" element={<WearablesComingSoon />} />

            <Route path="/ComprehensiveBilling" element={<Billing />} />

            <Route path="/Settings" element={<Settings />} />

            <Route path="/Calendar" element={<Calendar />} />
          </Routes>
        </ProfileCompletionGuard>
      </BlockAccessForIncorrectUserType>
    </Layout>
  );
}

export default function Pages() {
  return (
    <Router>
      <PagesContent />
    </Router>
  );
}
